const addItem = (arr, item) => [...arr, item];

const removeItem = (arr, item) => arr.filter(e => e !== item);

export const toggleItem = (arr, item) =>
  arr.indexOf(item) !== -1 ? removeItem(arr, item) : addItem(arr, item);
